/* eslint-disable */
export const D360_VOTE_START = 'D360_VOTE_START';
export const D360_VOTE_SUCCESS = 'D360_VOTE_SUCCESS';
export const D360_VOTE_FAIL = 'D360_VOTE_FAIL';

export const D360_VOTE_UPDATE_START = 'D360_VOTE_START';
export const D360_VOTE_UPDATE_SUCCESS = 'D360_VOTE_SUCCESS';
export const D360_VOTE_UPDATE_FAIL = 'D360_VOTE_FAIL';
